import {ControlUpdater} from '../../dynamic-field/control-updater.type';
import {FieldConfig} from '../../dynamic-field/field.config';
import {isCommonValidatorsChanged, updateCommonFields} from '../../dynamic-field/default-control-updater';
import {TextAreaFieldConfig} from './text-area-field.config';
import {buildTextareaFieldValidators} from './text-area-field.builder';

export const textareaFieldControlUpdater: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    updateCommonFields(currentFieldConfig, updateFieldConfig, control);

    if (isCommonValidatorsChanged(currentFieldConfig, updateFieldConfig)) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};

        const validators = buildTextareaFieldValidators(updatedFieldConfig);
        control.setValidators(validators);
        control.updateValueAndValidity();

        return;
    }

    if (updateFieldConfig.hasOwnProperty('maxLength')
        && (currentFieldConfig as TextAreaFieldConfig).maxLength !== (updateFieldConfig as TextAreaFieldConfig).maxLength
    ) {
        setTextareaFieldValidators(currentFieldConfig, updateFieldConfig, control);
        control.updateValueAndValidity();

        return;
    }

    if (updateFieldConfig.hasOwnProperty('autocompleteConfig')) {
        setTextareaFieldValidators(currentFieldConfig, updateFieldConfig, control);
        control.updateValueAndValidity();
    }
};

export const setTextareaFieldValidators = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};
    const validators = buildTextareaFieldValidators(updatedFieldConfig);
    control.setValidators(validators);
};
